<script lang="ts" setup>
import type { FieldData } from '~~/server/api/forms/form'

export interface FormKitCustomTextarea {
    data: FieldData;
}

const phoneRegex = [
    /^\+32\d{9}$/,
    /^\+359\d{8}$/,
    /^\+357\d{8}$/,
    /^\+420\d{9}$/,
    /^\+45\d{7,8}$/,
    /^\+372\d{8}$/,
    /^\+358\d{9}$/,
    /^\+33\d{9}$/,
    /^\+30\d{9,10}$/,
    /^\+31\d{9}$/,
    /^\+385\d{9}$/,
    /^\+353\d{9}$/,
    /^\+371\d{8}$/,
    /^\+352\d{8,9}$/,
    /^\+423\d{9}$/,
    /^\+370\d{8}$/,
    /^\+36\d{8,9}$/,
    /^\+49\d{10,11}$/,
    /^\+48\d{8,9}$/,
    /^\+351\d{9}$/,
    /^\+356\d{8,9}$/,
    /^\+43\d{8,9}$/,
    /^\+40\d{8,9}$/,
    /^\+421\d{9}$/,
    /^\+386\d{8}$/,
    /^\+34\d{8,9}$/,
    /^\+46\d{8,9}$/,
    /^\+39\d{10}$/,
    /^\+44\d{10}$/,
    /^\+380\d{9}$/,

    /^\+32(?:0)?[1-9]\d{7,8}$/,

    /^\+359(?:0)?[1-9]\d{6,8}$/,

    /^\+357(?:0)?[1-9]\d{7}$/,

    /^\+420(?:0)?[1-9]\d{8}$/,

    /^\+45(?:0)?[1-9]\d{7}$/,

    /^\+372(?:0)?[1-9]\d{6,7}$/,

    /^\+358(?:0)?[1-9]\d{4,11}$/,

    /^\+33(?:0)?[1-9]\d{8}$/,

    /^\+30(?:0)?[1-9]\d{9}$/,

    /^\+31(?:0)?[1-9]\d{8}$/,

    /^\+385(?:0)?[1-9]\d{7,8}$/,

    /^\+353(?:0)?[1-9]\d{6,8}$/,

    /^\+370(?:0)?[1-9]\d{7}$/,

    /^\+371(?:0)?[1-9]\d{7}$/,

    /^\+352(?:0)?[1-9]\d{3,11}$/,

    /^\+36(?:0)?[1-9]\d{7,8}$/,

    /^\+356(?:0)?[1-9]\d{7}$/,

    /^\+49(?:0)?[1-9]\d{2,12}$/,

    /^\+48(?:0)?[1-9]\d{8}$/,

    /^\+351(?:0)?[1-9]\d{8}$/,

    /^\+43(?:0)?[1-9]\d{3,12}$/,

    /^\+40(?:0)?[1-9]\d{8}$/,

    /^\+421(?:0)?[1-9]\d{8}$/,

    /^\+386(?:0)?[1-9]\d{7}$/,

    /^\+34(?:0)?[1-9]\d{8}$/,

    /^\+46(?:0)?[1-9]\d{6,12}$/,

    /^\+39(?:0\d{5,10}|3\d{8,10})$/,

    /^\+44(?:(?![1-9]\d{7}$)[1-9]\d{6,9})$/,

    /^\+380(?:0)?[1-9]\d{8}$/,
]

const validatePhoneNumber = (value: any) => {
    let result = false
    for (let index = 0; index < phoneRegex.length; index++) {
        if (phoneRegex[index]?.test(value)) {
            result = true
            break
        }
    }

    return result
}

const phone = (node: any) => validatePhoneNumber(node.value)

const props = defineProps<FormKitCustomTextarea>()
const model = ref<any>('')
</script>
<template>
  <div class="formkit-custom-tel-wrapper">
    <FormKit
      :id="props.data.name"
      v-model="model"
      :label="props.data.label"
      :help="props.data.help"
      :name="props.data.name"
      placeholder="+421xxxxxxxxx"
      :validation="[[props.data.validations?.includes('required') ? 'required' : ''], ['phone']]"
      :validation-rules="{ phone}"
      :validation-messages="{
        required:
          props.data.validation_messages?.['required'] ||
          $t('Telefónne číslo je povinný údaj'),
        phone: props.data.validation_messages?.['europeanPhoneNumber'] || $t('Číslo musí byť uvedené v medzinárodnom formáte a bez medzier.'),
      }"

      autocomplete="off"
      type="tel"
    />
  </div>
</template>
